/**
 * rAFAnimate is a low-level imperative-style animation helper.
 * It uses requestAnimationFrame to drive smooth animations specified in the 'progress' callback.
 * Duration in seconds.
 */
// tslint:disable-next-line:no-empty
export function rAFAnimate(progressCallback: (p: number) => void, start = () => {}, end = () => {}, duration = 0.5, easeOut = true) {
  const startTime = performance.now();
  let elapsedTime = 0;

  duration = duration * 1000;

  start();
  const animation = (timestamp: number) => {
    elapsedTime = timestamp - startTime;
    const progress = elapsedTime / duration;

    if (progress < 1) {
      progressCallback(easeOut ? easeOutQuad(progress) : progress);
      requestAnimationFrame(animation);
    } else {
      progressCallback(1);
      end();
    }
  };
  return requestAnimationFrame(animation);
}

const easeOutQuad = (t: number) => t * (2 - t);



// WEBPACK FOOTER //
// ./src/utils/rAFAnimate.tsx